import {Component, Input} from '@angular/core';
import {Filter} from "./filter";
import {FiltersService} from "../../filters.service";
import {FilterBlock} from "../filter-block";
import {FilterOperator} from "../../../../../config/filters/filter-operator.enum";
import {TranslateService} from "../../../../../shared/translate.service";

@Component({
  selector: 'app-filter-item',
  templateUrl: './filter-item.component.html',
  styleUrls: ['./filter-item.component.css']
})
export class FilterItemComponent {

  @Input() filter: Filter;

  @Input() filterBlock: FilterBlock;

  @Input() hideZeroes = false;

  @Input() enableOr = true;

  @Input() searchParameter: boolean;

  constructor(public translator: TranslateService,
              private filterService: FiltersService) {
  }

  toggleItem() {
    const defaultOperator = this.filterBlock.filterConfig.defaultOperator;
    switch (+defaultOperator) {
      case FilterOperator.EXCLUDE:
        this.markAsExcluded(true);
        break;
      case FilterOperator.OR:
        this.markAsOr(true);
        break;
      default:
        this.markAsAnd(true);
        break;
    }
  }

  preventDef(event) {
    if (event) {
      event.preventDefault();
    }
  }

  closeItem() {
    this.change({selected: false, or: false, excluded: false, toggle: true, remove: true});
    this.filterService.setTempFilters_q(this.filter, false);
  }

  markAsOr(toggle?: boolean) {
    this.change({selected: true, or: true, excluded: false, toggle: toggle});
  }

  markAsExcluded(toggle?: boolean) {
    this.change({selected: true, or: false, excluded: true, toggle: toggle});
  }

  markAsAnd(toggle?: boolean) {
    this.change({selected: true, or: false, excluded: false, toggle: toggle});
  }

  private change(flags: { selected: boolean, or: boolean, excluded: boolean, toggle?: boolean, remove?: boolean }) {
    if (flags.toggle && this.filter.value != 'work') {
      this.filter.selected = !this.filter.selected;
    } else {
      this.filter.selected = flags.selected;
    }
    this.filter.or = flags.or;
    this.filter.excluded = flags.excluded;
    this.filterService.triggerDependentFacetsUpdate(this.filter.field);
    if (this.searchParameter) {
      this.filterService.navigateByFilters(flags.remove, flags.toggle, false, this.filter.value);
    } else {
      this.filterService.navigateByFilters(flags.remove);
    }
  }

  public setWorkBibliograficzneAsDefault(flags: { selected: boolean, or: boolean, excluded: boolean, toggle?: boolean,
    remove?: boolean, filter: Filter }) {
    if (flags.toggle && (flags.filter.value != 'work' && flags.filter.value != 'work_materialization' && flags.filter.value != 'work_work')) {
      flags.filter.selected = !flags.filter.selected;
    } else {
        flags.filter.selected = flags.selected;
    }
    flags.filter.or = flags.or;
    flags.filter.excluded = flags.excluded;
    this.filterService.triggerDependentFacetsUpdate(flags.filter.field);

    if(flags.filter.value === 'work' || flags.filter.value === '_q')
    {
      if (this.searchParameter) {
        this.filterService.navigateByFilters(flags.remove, flags.toggle, false, flags.filter.value);
      } else {
        this.filterService.navigateByFilters(flags.remove);
      }
    }
  }

  canShowExclude() {
    return !this.filterBlock.filterConfig.disableExclude && this.filterBlock.filterConfig.minElements === 0;
  }

  canShowOr() {
    return !this.filterBlock.filterConfig.disableOr && this.enableOr;
  }

  itemLabel(){
    return this.itemValueLabel();
  }

  itemValueLabel() {
    return this.translator.translate(this.filter.value);
  }

  closeLabel() {
    return this.translator
      .translate('ChoosenFilter.remove')+' '+this.itemValueLabel();
  }

  orLabel() {
    return this.translator.translate('or')+' '+this.itemValueLabel();
  }

  excludeLabel() {
    return this.translator.translate('exclude')+' '+this.itemValueLabel();
  }
}
